import React from 'react'

const Backend = ({isDarkMode}) => {
    const bodyClass = `skills__content ${isDarkMode ? 'dark-mode': ''}`

  return (
    <div className={bodyClass}>
    <h3 className="skills__title">Backend Development</h3> 

    <div className="skills__box">
        <div className="skills__group">

            <div className="skills__data">
                <i className="uil uil-check-circle"></i>

                <div>
                    <h3 className="skills__name">ExpressJS</h3>
                    <span className="skills__level">Basic</span>
                </div>
            </div>

            <div className="skills__data">
                <i className="uil uil-check-circle"></i>

                <div>
                    <h3 className="skills__name">NodeJs</h3>
                    <span className="skills__level">Basic</span>
                </div>
            </div>

            <div className="skills__data">
                <i className="uil uil-check-circle"></i>

                <div>
                    <h3 className="skills__name">MongoDB</h3>
                    <span className="skills__level">Intermediate</span>
                </div>
            </div>
        </div>
        <div className="skills__group">
            <div className="skills__data">
                <i className="uil uil-check-circle"></i>

                <div>
                    <h3 className="skills__name">MySQL</h3>
                    <span className="skills__level">Basic</span>
                </div>
            </div>

            <div className="skills__data">
                <i className="uil uil-check-circle"></i>

                <div>
                    <h3 className="skills__name">APIs</h3>
                    <span className="skills__level">Basic</span>
                </div>
            </div>

            <div className="skills__data">
                <i className="uil uil-check-circle"></i>

                <div>
                    <h3 className="skills__name">FireBase</h3>
                    <span className="skills__level">Basic</span>
                </div>
            </div>
        </div>
    </div>

</div>
  )
}

export default Backend
